import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

import './scss/app-loading.scss';
import Color from '@/tool/color';
import AppPortal from './app-portal';
import moStore from '@store/index';

interface IProps {}
interface IState {}

const AppLoading = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const { isLoading } = moStore;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <AppPortal>
      {isLoading ? (
        <section className="app-loading">
          <div className="lds-spinner">
            <div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div>
            <div></div><div></div><div></div><div></div>
          </div>
        </section>
      ) : null}
    </AppPortal>
  );
};

export default observer(AppLoading);
